import { QueryClient } from '@tanstack/react-query';

export const defaultRetry = (failureCount: number, error: any) => {
  // Don't retry on authentication/session errors - these will trigger logout
  if (error?.message?.includes('Authentication') ||
      error?.message?.includes('Session expired') ||
      error?.message?.includes('log in again') ||
      error?.response?.status === 403 ||
      error?.response?.status === 401) {
    return false;
  }
  // Retry up to 2 times for other errors
  return failureCount < 2;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: defaultRetry,
      // Keep queries fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Garbage collection time - cache for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Refetch on window focus to ensure fresh data
      refetchOnWindowFocus: true,
      // Don't refetch on reconnect if we have cached data
      refetchOnReconnect: 'always',
    },
    mutations: {
      retry: false, // Don't retry mutations by default
    },
  },
});
